"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Multiselect = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectSpread6 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styles = require("./styles");

var _Select = _interopRequireDefault(require("@mui/material/Select"));

var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));

var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));

var _OutlinedInput = _interopRequireDefault(require("@mui/material/OutlinedInput"));

var _EditGroup = require("../../organisms/EditGroup");

var _Modal = require("../../organisms/Modal");

var _ButtonV = require("../ButtonV2");

var _search = _interopRequireDefault(require("../../../assets/images/Icons/search.svg"));

var _settings = _interopRequireDefault(require("../../../assets/images/Icons/settings.svg"));

var _jsxRuntime = require("react/jsx-runtime");

//styles
//components
//svg
var Multiselect = function Multiselect(_ref) {
  var arrayData = _ref.arrayData,
      userId = _ref.userId,
      token = _ref.token,
      showSearchBar = _ref.showSearchBar,
      _ref$placeHolder = _ref.placeHolder,
      placeHolder = _ref$placeHolder === void 0 ? "Buscar grupo" : _ref$placeHolder,
      _ref$textButton = _ref.textButton,
      textButton = _ref$textButton === void 0 ? "Editar grupos" : _ref$textButton;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selectValues = _useState4[0],
      setSelectValues = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      text = _useState6[0],
      setText = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isEditGroupVisible = _useState8[0],
      setIsEditGroupVisible = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      isItemListVisible = _useState10[0],
      setIsItemListVisible = _useState10[1];

  var currentUser = arrayData.find(function (user) {
    return user.idUser === userId;
  });

  var _ref2 = currentUser || {},
      idUser = _ref2.idUser,
      groups = _ref2.groups;

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      selectedItems = _useState12[0],
      setSelectedItems = _useState12[1];

  var _useState13 = (0, _react.useState)({
    show: false,
    title: "Actualización completa",
    message: "",
    icon: "success"
  }),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      modalData = _useState14[0],
      setModalData = _useState14[1];

  var loadUserGroups = function loadUserGroups(updatedValues) {
    if (updatedValues && updatedValues.length > 0) {
      setSelectValues(function (prevValues) {
        return (0, _objectSpread6.default)((0, _objectSpread6.default)({}, prevValues), {}, (0, _defineProperty2.default)({}, idUser, updatedValues.map(function (groupInfo) {
          return groupInfo.groupName;
        })));
      });
    } else {
      var hasUserContentGroup1 = groups.some(function (group) {
        return group.userContentGroup === 1;
      });

      if (hasUserContentGroup1) {
        var initialSelectedValues = groups.filter(function (group) {
          return group.userContentGroup === 1;
        }).map(function (group) {
          return group.groupName;
        }) || [];
        setSelectValues(function (prevValues) {
          return (0, _objectSpread6.default)((0, _objectSpread6.default)({}, prevValues), {}, (0, _defineProperty2.default)({}, idUser, initialSelectedValues));
        });
      } else {
        setSelectValues(function (prevValues) {
          return (0, _objectSpread6.default)((0, _objectSpread6.default)({}, prevValues), {}, (0, _defineProperty2.default)({}, idUser, ["Sin grupos asignados"]));
        });
      }
    }

    setFilters(groups ? groups : []);
  };

  (0, _react.useEffect)(function () {
    loadUserGroups();
  }, [idUser, groups]);

  var onChange = function onChange(evt) {
    setText(evt.target.value);
  };

  var handleChange = function handleChange(userId) {
    return function (event) {
      var value = event.target.value;
      var filteredArrayCopy = (0, _toConsumableArray2.default)(filters);
      var updatedValues = groups.map(function (group) {
        var isSelected = value.includes(group.groupName);
        return (0, _objectSpread6.default)((0, _objectSpread6.default)({}, group), {}, {
          userContentGroup: isSelected ? 1 : 0
        });
      });
      setSelectedItems(updatedValues.filter(function (group) {
        return group.userContentGroup === 1;
      }).map(function (group) {
        return group.groupName;
      }));
      setSelectValues(function (prevValues) {
        return (0, _objectSpread6.default)((0, _objectSpread6.default)({}, prevValues), {}, (0, _defineProperty2.default)({}, userId, updatedValues.filter(function (group) {
          return group.userContentGroup === 1;
        }).map(function (group) {
          return group.groupName;
        })));
      });
      var changes = updatedValues.reduce(function (result, group, index) {
        if (group.userContentGroup !== filteredArrayCopy[index].userContentGroup) {
          result.push({
            groupId: group.groupId,
            userContentGroup: group.userContentGroup
          });
        }

        return result;
      }, []);
      var updatedGroups = changes.filter(function (change) {
        return change.userContentGroup === 1;
      }).map(function (change) {
        return change.groupId;
      });
      var deletedGroups = changes.filter(function (change) {
        return change.userContentGroup === 0;
      }).map(function (change) {
        return change.groupId;
      });

      if (updatedGroups.length > 0) {
        updateGroup(updatedGroups);
      }

      if (deletedGroups.length > 0) {
        deleteGroup(deletedGroups);
      }
    };
  }; //actualiza los grupos seleccionados


  var updateGroup = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(groupsIds) {
      var body, response;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              body = {
                userIds: [userId],
                groupsIds: groupsIds
              };
              _context.next = 4;
              return _axios.default.post("".concat(process.env.REACT_APP_USERS_ONBOARDING_ENDPOINT, "/update"), body, {
                headers: {
                  Authorization: token
                }
              });

            case 4:
              response = _context.sent;
              console.log("grupo actualizado correctamente", response.data.body);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error("Error al cambiar grupos de usuarios:", _context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function updateGroup(_x) {
      return _ref3.apply(this, arguments);
    };
  }(); //Elimina todos los grupos de usuarios seleccionados


  var deleteGroup = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(groups) {
      var body, response;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              body = {
                userIds: [userId],
                groupsIds: groups
              };
              _context2.next = 4;
              return _axios.default.post("".concat(process.env.REACT_APP_USERS_ONBOARDING_ENDPOINT, "/delete"), body, {
                headers: {
                  Authorization: sessionStorage.getItem("jwt")
                }
              });

            case 4:
              response = _context2.sent;
              console.log("borrado correctamente", response.data.body);
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error("Error al eliminar grupos de usuarios:", _context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function deleteGroup(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {}, [selectValues]);
  (0, _react.useEffect)(function () {
    var filteredArray = (groups === null || groups === void 0 ? void 0 : groups.slice()) || [];
    var normalizedText = text.trim().toLowerCase();

    if (normalizedText.length > 0) {
      filteredArray = filteredArray.filter(function (option) {
        var _option$groupName;

        return option === null || option === void 0 ? void 0 : (_option$groupName = option.groupName) === null || _option$groupName === void 0 ? void 0 : _option$groupName.toLowerCase().includes(normalizedText);
      });
    }

    setFilters(filteredArray);
    console.log("filteredArray:", filteredArray);
  }, [text]);
  var ITEM_HEIGHT = 48;
  var ITEM_PADDING_TOP = 8;
  var MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: "auto",
        display: isItemListVisible ? "block" : "none",
        left: "1013px"
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [currentUser && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Select.default, {
      labelId: "demo-multiple-checkbox-label-".concat(idUser),
      id: "demo-multiple-checkbox-".concat(idUser),
      multiple: true,
      value: selectValues[idUser] || [],
      onChange: handleChange(idUser),
      input: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
        sx: {
          width: "80%",
          height: "34px",
          paddingBottom: "1px solid #F0F0F0"
        }
      }),
      renderValue: function renderValue(selected) {
        return selected.join(", ");
      },
      MenuProps: MenuProps,
      sx: {
        width: "80%",
        height: "24px",
        "& div": {
          color: "#707070",
          fontSize: "12px"
        }
      },
      children: [showSearchBar && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        sx: {
          maxHeight: "34px",
          paddingLeft: "10px",
          "& .search-bar-filter": {
            display: "flex",
            gap: "10px",
            input: {
              border: "none",
              background: "transparent",
              "::placeholder": {
                fontSize: "12px",
                color: "#CBCBCB"
              },
              ":focus-visible, :hover": {
                border: "none",
                background: "transparent",
                outline: "none"
              }
            },
            ":focus-visible, :hover": {
              background: "transparent"
            }
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "search-bar-filter",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _search.default,
            alt: "search icon"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            type: "text",
            placeholder: placeHolder,
            value: text,
            onChange: onChange
          })]
        })
      }), groups && groups.filter(function (group) {
        return group.groupId !== "Sin id" && group.groupName !== "No tiene grupo asignado";
      }).map(function (group) {
        var _selectValues$idUser;

        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
          value: group.groupName,
          sx: {
            paddingLeft: "0px",
            maxHeight: "34px",
            ":focus-visible, :hover": {
              border: "none",
              background: "transparent"
            }
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
            checked: (_selectValues$idUser = selectValues[idUser]) === null || _selectValues$idUser === void 0 ? void 0 : _selectValues$idUser.includes(group.groupName),
            sx: {
              maxHeight: "34px",
              "&.Mui-checked": {
                color: "#85BC5B"
              },
              "input, svg": {
                maxWidth: "12px",
                maxHeight: "12px"
              }
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
            primary: group.groupName,
            sx: {
              span: {
                fontSize: "12px",
                color: "#000000"
              },
              "input, svg": {
                maxWidth: "12px",
                maxHeight: "12px"
              }
            }
          })]
        }, group.groupId);
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        sx: {
          minHeight: "34px",
          paddingLeft: "10px",
          ".btn-edit-group": {
            color: "#E33AA9",
            border: "none",
            background: "transparent",
            display: "flex",
            gap: "10px",
            alignItems: "center"
          },
          ":focus-visible, :hover": {
            border: "none",
            background: "transparent"
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          className: "btn-edit-group",
          onClick: function onClick() {
            setIsItemListVisible(false);
            setIsEditGroupVisible(true);
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _settings.default,
            className: "icon",
            alt: "search icon"
          }), textButton]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditGroup.EditGroup, {
      token: token,
      show: isEditGroupVisible,
      onClose: function onClose() {
        setIsEditGroupVisible(false);
        setIsItemListVisible(true);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, (0, _objectSpread6.default)((0, _objectSpread6.default)({}, modalData), {}, {
      onClickBtnDefault: function onClickBtnDefault() {
        return setModalData(function (prev) {
          return (0, _objectSpread6.default)((0, _objectSpread6.default)({}, prev), {}, {
            show: false
          });
        });
      }
    }))]
  });
};

exports.Multiselect = Multiselect;